// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "@hotwired/hotwire-native-bridge"
import "./controllers"
import "./lib/turbo_mount"
import TurboPower from 'turbo_power'
TurboPower.initialize(Turbo.StreamActions)
